<template>
  <article>
    <section class="news">
      <div class="wrapper">
        <div class="subhead">
          <span>嗨浪新闻</span>
        </div>
        <div class="pure-g">
          <div class="pure-u-1 pure-u-md-1-3" v-for="(item, index) in list" :key="index"
            @click="$router.push('/news/' + item.id)">
            <div class="p1-box">
              <div class="wrap">
                <img style="height: 280px;" :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" class="pure-img" oncontextmenu="return false;">
                <p
                  style="height: 50px;line-height: 50px;background: rgba(0, 0, 0, 0.4);position: relative;margin-top: -50px;color: #ffffff;text-align: center;">
                  {{ item.imageTitle }}</p>
                <p class="list-title" v-html="item.imageContent"></p>
              </div>
            </div>
          </div>
        </div>
        <!-- <el-pagination background layout="prev, pager, next" :page-size="count" :total="total"
          @current-change="handleCurrentChange" :current-page.sync="page" style="text-align: center;">
        </el-pagination> -->
      </div>
    </section>
    <section class="news">
      <div class="wrapper">
        <div class="subhead">
          <span>行业新闻</span>
        </div>
        <div class="pure-g">
          <div class="pure-u-1 pure-u-md-1-3" v-for="(item, index) in industryList" :key="index"
            @click="$router.push('/news/' + item.id)">
            <div class="p1-box">
              <div class="wrap">
                <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" class="pure-img"
                  style="height: 280px;" oncontextmenu="return false;">
                <p
                  style="height: 50px;line-height: 50px;background: rgba(0, 0, 0, 0.4);position: relative;margin-top: -50px;color: #ffffff;text-align: center;">
                  {{ item.imageTitle }}</p>
                <p class="list-title" v-html="item.imageContent"></p>
              </div>
            </div>
          </div>
        </div>
        <!-- <el-pagination background layout="prev, pager, next" :page-size="count" :total="total"
          @current-change="handleCurrentChange" :current-page.sync="page" style="text-align: center;">
        </el-pagination> -->
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "News",
  data() {
    return {
      page: 1,
      count: 6,
      total: 0,
      list: [],
      // 行业新闻
      industryList: []
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$http.get("/website/hnWebsiteContentInfo/getList", {
        firstType: "4"
      }, res => {
        if (res.code == '200') {
          this.list = res.data.嗨浪新闻[1]
          this.industryList = res.data.行业新闻[1]
        }
      })
    }
  }
}
</script>
<style>
@import "~@/assets/styles/news.css";

.news .picture {
  height: 15em;
  background-size: cover;
}

.list-title {
  line-height: 2em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
